import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=0f00c969&scoped=true&"
import script from "./signup.vue?vue&type=script&lang=js&"
export * from "./signup.vue?vue&type=script&lang=js&"
import style0 from "./signup.vue?vue&type=style&index=0&id=0f00c969&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00c969",
  null
  
)

export default component.exports